import React from "react";

export const Countries = () => {
  const countries = [
    {
      flag: "https://images.pexels.com/photos/1202723/pexels-photo-1202723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      country: "United States",
      amount: "3,455",
    },
   
    {
      flag: "https://images.pexels.com/photos/1202723/pexels-photo-1202723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      country: "United States",
      amount: "3,455",
    },
   
    {
      flag: "https://images.pexels.com/photos/1202723/pexels-photo-1202723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      country: "United States",
      amount: "3,455",
    },
   
    {
      flag: "https://images.pexels.com/photos/1202723/pexels-photo-1202723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      country: "United States",
      amount: "3,455",
    },
   
    {
      flag: "https://images.pexels.com/photos/1202723/pexels-photo-1202723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      country: "United States",
      amount: "3,455",
    },
   
    {
      flag: "https://images.pexels.com/photos/1202723/pexels-photo-1202723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      country: "United States",
      amount: "3,455",
    },
   
    {
      flag: "https://images.pexels.com/photos/1202723/pexels-photo-1202723.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=1",
      country: "United States",
      amount: "3,455",
    },
   
  
  ];
  return (
    <div className="bg-[#f0f0f0] px-4 py-3 rounded-lg  dark:bg-[#282828] w-full">
      <h1 className="text-xl">Top Countries</h1>
      <div className="py-4">
        {countries.map((country) => (
          <div className="flex items-center justify-between">
            <div className="flex items-center space-x-4 py-2">
              <img
                className="w-10 h-10 object-cover rounded-full"
                src={country.flag}
                alt=""
              />
              <p>{country.country}</p>
            </div>
            <p className="font-semibold">${country.amount}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
